// The one user-facing name for the assistant, shared by the chat drawer, the
// voice dock and the Ambient Agent card. They are one helper, so they read as
// one name. Twin constant lives in gaintime-bot-webhook/utils/assistantIdentity.js
// (separate package, so the two are kept in sync by hand).
//
// The assistant says its own name only in the voice session greeting
// (FloatingMicAssistant/voice/useVoiceConversation.js). Everywhere else the
// name is a UI label and the assistant speaks as "I".
//
// NOT this name: meeting ratings, strategic-goal tagging and the Insights
// analysis are produced by separate services, so their copy says "Gaintime".
export const ASSISTANT_NAME = "GT Assistant";

// For the header pill, where the glyph sits next to the orb icon.
export const ASSISTANT_SHORT_NAME = "GT";
